var map = {
	"./american-roulette/resources/js/pages/admin/settings": [
		54874,
		6065,
		7793
	],
	"./baccarat/resources/js/pages/admin/settings": [
		69256,
		6065,
		7961
	],
	"./blackjack/resources/js/pages/admin/settings": [
		62787,
		6065,
		1018
	],
	"./casino-holdem/resources/js/pages/admin/settings": [
		86588,
		6065,
		3849
	],
	"./crash/resources/js/pages/admin/settings": [
		66868,
		6065,
		9090
	],
	"./crypto-prediction/resources/js/pages/admin/settings": [
		6719,
		6065,
		160,
		9799
	],
	"./dice-3d/resources/js/pages/admin/settings": [
		84376,
		6065,
		3019
	],
	"./dice/resources/js/pages/admin/settings": [
		25846,
		6065,
		3644
	],
	"./european-roulette/resources/js/pages/admin/settings": [
		641,
		6065,
		4063
	],
	"./heads-or-tails/resources/js/pages/admin/settings": [
		96457,
		6065,
		4661
	],
	"./horse-racing/resources/js/pages/admin/settings": [
		62072,
		6065,
		914,
		5369,
		3953,
		800,
		9186,
		436,
		9230,
		2027,
		4725,
		9024,
		3128
	],
	"./keno/resources/js/pages/admin/settings": [
		45509,
		6065,
		9073
	],
	"./lucky-wheel/resources/js/pages/admin/settings": [
		4548,
		6065,
		2421
	],
	"./multiplayer-blackjack/resources/js/pages/admin/settings": [
		15028,
		6065,
		3360
	],
	"./multiplayer-roulette/resources/js/pages/admin/settings": [
		81230,
		6065,
		7243
	],
	"./payments/resources/js/pages/admin/settings": [
		77788,
		8687
	],
	"./plinko/resources/js/pages/admin/settings": [
		13162,
		6065,
		5983
	],
	"./raffle/resources/js/pages/admin/settings": [
		81177,
		6331
	],
	"./sic-bo/resources/js/pages/admin/settings": [
		3149,
		6065,
		62
	],
	"./slots-3d/resources/js/pages/admin/settings": [
		22519,
		6065,
		9609,
		7291,
		2516
	],
	"./slots/resources/js/pages/admin/settings": [
		50128,
		6065,
		9609,
		7291,
		9474
	],
	"./video-poker/resources/js/pages/admin/settings": [
		91266,
		6065,
		3126
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 19943;
module.exports = webpackAsyncContext;